// extracted by css-extract-rspack-plugin
export default {"cls1":"MultiPaperModal-cls1_C-f","cls2":"MultiPaperModal-cls2_O2R MultiPaperModal-cls1_C-f"};